import { ulid } from 'ulid'

export function useDeviceUid() {
  if (!import.meta.client) return ''

  const UID_KEY = 'tgi_rp_uid'
  let uid = localStorage.getItem(UID_KEY) || ''

  if (!uid) {
    uid = ulid()
    localStorage.setItem(UID_KEY, uid)
  }

  return uid
}
